import React from 'react';
import { Card, Text } from 'src/components';
import { colors } from 'src/theme';

export interface ActionLabelCardProps {
  text?: string;
  className?: string;
}

export const ActionLabelCard: React.FC<ActionLabelCardProps> = ({ text, className }) => {
  if (!text) return null;
  return (
    <Card radius={10} padding="12px 16px" background={colors.offerPromoBg} className={className}>
      <Text type="tiny" color={colors.text3}>{text}</Text>
    </Card>
  );
};
